export const stripHtmlTags = (htmlString?: string): string =>
  (htmlString || '')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&[a-z]+;/gi, '')
    .trim();
